import { createSlice } from "@reduxjs/toolkit";
import useApi from "../api";
import { handleRetriveError } from "../utils";

// Define the initial state
interface CollectionsState {
    results: any[];
    collectionsLoaded: boolean;
}

const initialState: CollectionsState = {
    results: [],
    collectionsLoaded: false,
};

// Create the slice
const collectionsSlice = createSlice({
    name: "collections",
    initialState,
    reducers: {
        setCollections(state, action) {
            state.results = action.payload;
        },
    },
});

// Export the action so it can be dispatched
export const { setCollections } = collectionsSlice.actions;

// Async thunk to fetch collections from API
export const fetchCollections = () => async (dispatch: any) => {
    const api = useApi();
    try {
        const response = await api.getCollections();
        dispatch(setCollections(response));
    } catch (error) {
        handleRetriveError(error);
    }
};

export default collectionsSlice.reducer;
